// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBOZJgoNI3F87EqeI3t9Hu0s5g-G1rFRLA",
  authDomain: "heaviside-31e44.firebaseapp.com",
  projectId: "heaviside-31e44",
  storageBucket: "heaviside-31e44.firebasestorage.app",
  messagingSenderId: "733498606172",
  appId: "1:733498606172:web:ff5dc9f9f066e0262f1c99",
  measurementId: "G-8EP2CTBFXD"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app, "contactmessages");